import * as React from 'react'

export const ColouredSuccesCheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20.0002 0C8.97244 0 0 8.97175 0 20.0002C0 31.0287 8.97175 39.9997 20.0002 39.9997C31.0287 39.9997 40.0004 31.028 40.0004 20.0002C40.0004 8.97244 31.0287 0 20.0002 0ZM20.0002 36.7821C10.7467 36.7821 3.21903 29.2537 3.21903 20.0002C3.21903 10.7467 10.7474 3.21834 20.0002 3.21834C29.253 3.21834 36.7821 10.7467 36.7821 20.0002C36.7821 29.2537 29.2537 36.7821 20.0002 36.7821Z"
        fill="url(#paint0_linear_975_38417)"
      />
      <path
        d="M25.7794 14.8191L16.7508 23.5403L13.0382 20.16C12.3806 19.5618 11.3629 19.6089 10.7648 20.2666C10.1667 20.9242 10.2145 21.9412 10.8714 22.54L15.7 26.9365C16.0074 27.2162 16.3957 27.3554 16.7834 27.3554C17.187 27.3554 17.5906 27.2045 17.9014 26.904L28.0154 17.1341C28.6543 16.5166 28.6723 15.4983 28.0548 14.8586C27.438 14.2196 26.4197 14.201 25.7794 14.8191Z"
        fill="url(#paint1_linear_975_38417)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_975_38417"
          x1="20.0002"
          y1="35.0438"
          x2="20.0002"
          y2="4.95592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#459A18" />
          <stop offset="1" stopColor="#67D42D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_975_38417"
          x1="19.4264"
          y1="25.7459"
          x2="19.4264"
          y2="15.9759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#459A18" />
          <stop offset="1" stopColor="#67D42D" />
        </linearGradient>
      </defs>
    </svg>
  )
}
